import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const feedViewDefaultVariants = {}
const feedViewCompoundVariants = []

const feedViewSlotNames = [
  [
    "feedWrapper",
    "feed-view__feedWrapper"
  ],
  [
    "mobileHeader",
    "feed-view__mobileHeader"
  ],
  [
    "headerRow1",
    "feed-view__headerRow1"
  ],
  [
    "headerActions",
    "feed-view__headerActions"
  ],
  [
    "headerRow2",
    "feed-view__headerRow2"
  ],
  [
    "backButton",
    "feed-view__backButton"
  ],
  [
    "backButtonIcon",
    "feed-view__backButtonIcon"
  ],
  [
    "listIconButton",
    "feed-view__listIconButton"
  ],
  [
    "saveSearchIconButton",
    "feed-view__saveSearchIconButton"
  ],
  [
    "saveSearchIconButtonSaved",
    "feed-view__saveSearchIconButtonSaved"
  ],
  [
    "headerCounter",
    "feed-view__headerCounter"
  ],
  [
    "headerCounterBold",
    "feed-view__headerCounterBold"
  ],
  [
    "feedLane",
    "feed-view__feedLane"
  ],
  [
    "feedScrollArea",
    "feed-view__feedScrollArea"
  ],
  [
    "feedCardSlot",
    "feed-view__feedCardSlot"
  ],
  [
    "feedAdSlot",
    "feed-view__feedAdSlot"
  ],
  [
    "desktopNavArrows",
    "feed-view__desktopNavArrows"
  ],
  [
    "srOnly",
    "feed-view__srOnly"
  ]
]
const feedViewSlotFns = /* @__PURE__ */ feedViewSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, feedViewDefaultVariants, getSlotCompoundVariant(feedViewCompoundVariants, slotName))])

const feedViewFn = memo((props = {}) => {
  return Object.fromEntries(feedViewSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const feedViewVariantKeys = []
const getVariantProps = (variants) => ({ ...feedViewDefaultVariants, ...compact(variants) })

export const feedView = /* @__PURE__ */ Object.assign(feedViewFn, {
  __recipe__: false,
  __name__: 'feedView',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: feedViewVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, feedViewVariantKeys)
  },
  getVariantProps
})